/* eslint-disable no-console */
import { useSelector } from "react-redux";

import useNotificationCounts from "../hooks/useNotificationsCount";
import avatarImg from "../../../assets/images/avatar.svg";
// import NewChatIcon from "../../../assets/NewChatIcon";
import UserChatBubble from "../../Forms/FirmUserBtn";

import { formatName } from "./ChatWindow";
import "./provider-list.css";
// import chatIcon from "../../../assets/chat-icon-color.svg";

const UsersList = ({
  users,
  // selectedUser,
  onSelectUser,
  loading,
  error,
  typingUsers,
  unreadCounts,
  // latestMessages,
}) => {
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  console.log(userOnlineStatus);
  const { allThreads } = useNotificationCounts();
  console.log(allThreads);

  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#64748b" }}>
        <div
          style={{
            width: "24px",
            height: "24px",
            border: "3px solid #f1f5f9",
            borderTop: "3px solid var(--primary, #3b82f6)",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 12px",
          }}
        />
        <p style={{ margin: 0, fontSize: "14px" }}>Loading users...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#ef4444" }}>
        <div style={{ fontSize: "24px", marginBottom: "8px" }}>⚠️</div>
        <p style={{ margin: 0, fontSize: "14px" }}>{error}</p>
      </div>
    );
  }

  // Sort users by last activity/typing status
  const sortedUsers = [...users].sort((a, b) => {
    const aThreadId = a.threadId || a.id;
    const bThreadId = b.threadId || b.id;

    // Check if user is typing
    const aTyping = typingUsers[aThreadId] && Object.keys(typingUsers[aThreadId]).length > 0;
    const bTyping = typingUsers[bThreadId] && Object.keys(typingUsers[bThreadId]).length > 0;

    if (aTyping && !bTyping) return -1;
    if (!aTyping && bTyping) return 1;

    // Check unread count
    const aUnread = unreadCounts[aThreadId] || 0;
    const bUnread = unreadCounts[bThreadId] || 0;

    if (aUnread > 0 && bUnread === 0) return -1;
    if (aUnread === 0 && bUnread > 0) return 1;

    // Sort by last message time
    const aTime = a.last_message_preview?.created_at || a.created_at || 0;
    const bTime = b.last_message_preview?.created_at || b.created_at || 0;

    return new Date(bTime) - new Date(aTime);
  });

  return (
    <>
      <div
        style={{ flex: 1, minHeight: 0, overflow: "auto", scrollbarWidth: "none" }}
        className="chat-odd-even-color chat-sidebar-list"
      >
        {sortedUsers.map((user) => {
          const userThreadId = user.threadId || user.id;
          // const userUnreadCount = unreadCounts[userThreadId] || 0;
          console.log(allThreads);
          console.log(userThreadId);
          const userUnreadCount = allThreads[userThreadId] ?? 0;
          console.log(userUnreadCount);
          const _isTyping =
            typingUsers[userThreadId] && Object.keys(typingUsers[userThreadId]).length > 0;
          console.log(user);
          const isOnline =
            user?.is_online ||
            userOnlineStatus?.[user?.other_participant_id]?.isOnline ||
            userOnlineStatus?.[user?.id]?.isOnline;
          // Group buttons get the same border as the user buttons: green while any member is online.
          const groupOnline = user?.group_member_avatars?.some(
            (member) => userOnlineStatus?.[member?.id]?.isOnline
          );
          return (
            <div
              key={user.id}
              onClick={() => onSelectUser(user)}
              className="onHoverChat"
              style={{
                // Same distance as the header tab labels from the window edge.
                paddingLeft: "8.5px",
                paddingRight: "8.5px",

                // borderBottom: "1px solid #f1f5f9",
                cursor: "pointer",
                height: user?.thread_type === "group" ? "60px" : "25px",
                // backgroundColor: selectedUser?.id === user.id ? "#f0f7ff" : "transparent",
                // borderRight:
                //   selectedUser?.id === user.id ? "3px solid var(--primary, #3b82f6)" : "none",
                transition: "all 0.2s ease",
                position: "relative",
                display: user?.thread_type === "group" ? "flex" : "",
                justifyContent: user?.thread_type === "group" ? "center" : "center",
              }}
              // onMouseEnter={(e) => {
              //   if (selectedUser?.id !== user.id) {
              //     e.target.style.backgroundColor = "#f8fafc";
              //   }
              // }}
              // onMouseLeave={(e) => {
              //   if (selectedUser?.id !== user.id) {
              //     e.target.style.backgroundColor = "transparent";
              //   }
              // }}
            >
              {/* {isTyping && (
              <div
                style={{
                  position: "absolute",
                  top: "6px",
                  right: "8px",
                  color: "#10b981",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                typing...
              </div>
            )} */}
              {userUnreadCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "4px",
                    right: "5px",
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "50%",
                    width: "18px",
                    height: "18px",
                    fontSize: "10px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // marginLeft: "8px",
                    zIndex: "10",
                  }}
                >
                  {userUnreadCount}
                </span>
              )}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  height: user?.thread_type === "group" ? "60px" : "25px",
                  justifyContent: user?.thread_type === "group" ? "center" : "center",
                }}
              >
                {user?.thread_type === "group" ? (
                  <>
                    {" "}
                    {/* <div
                    style={{
                      width: "29px",
                      height: "29px",
                      borderRadius: "50%",
                      // backgroundColor: selectedUser?.id === user.id ? "var(--primary)" : "#e2e8f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: selectedUser?.id === user.id ? "white" : "#64748b",
                      fontWeight: "600",
                      fontSize: "14px",
                      // backgroundImage: user.avatar ? `url(${user.avatar})` : "none",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <NewChatIcon />
                  </div> */}
                    <div style={{ flex: 1 }}>
                      <div>
                        <div
                          style={{
                            flexShrink: 0,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "column",
                              justifyContent: "center",
                              width: "max-content",
                              margin: "0 auto",
                              padding: "0 10px",
                              border: `2.5px solid ${groupOnline ? "#009900" : "var(--primary-20)"}`,
                              borderRadius: "12px",
                              background: groupOnline ? "#DDFFD0" : "var(--primary-2)",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-end",
                                height: "19px",
                                fontWeight: "600",
                                lineHeight: "1",
                              }}
                            >
                              {formatName(user?.name)}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                fontSize: "14px",
                              }}
                            >
                              <div>
                                <div
                                  style={{
                                    margin: "0 0 0px 0",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                    fontSize: "14px",
                                    display: "flex",
                                    height: "29px",
                                    alignItems: "center",
                                    position: "relative",
                                  }}
                                >
                                  {user?.group_member_avatars?.slice(0, 5).map((u, index) => {
                                    const isActive = userOnlineStatus?.[u?.id]?.isOnline || false;
                                    const totalAvatars = user?.group_member_avatars?.length || 0;
                                    console.log(totalAvatars);
                                    const isLastVisible = index === 4 && totalAvatars > 5;
                                    if (isLastVisible) {
                                      console.log(user?.group_member_avatars);
                                    }
                                    console.log(isLastVisible);
                                    return (
                                      <div
                                        key={index}
                                        className="ic ic-avatar-index has-avatar-icon-index has-cover-img"
                                        style={{
                                          width: `${29}px`,
                                          height: `${29}px`,
                                          borderRadius: "50%",
                                          overflow: "hidden",
                                          marginLeft: index > 0 ? "-12px" : "0px", // Overlap avatars
                                          position: "relative",
                                          flexShrink: 0,
                                          zIndex: 10 - index, // Higher z-index for first avatars
                                        }}
                                      >
                                        {!isLastVisible ? (
                                          <>
                                            <img
                                              src={u?.avatar_url || avatarImg}
                                              style={{
                                                width: `${28}px`,
                                                height: `${28}px`,
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                              }}
                                              alt="Profile"
                                            />
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: `${29}px`,
                                                height: `${29}px`,
                                                borderRadius: "50%",
                                                border: isActive
                                                  ? "2.5px solid #009900"
                                                  : "2.5px solid var(--primary-20)",
                                                pointerEvents: "none",
                                                zIndex: "1",
                                              }}
                                            />
                                          </>
                                        ) : (
                                          // Show +X for remaining members
                                          <div
                                            style={{
                                              width: `${29}px`,
                                              minWidth: "29px",
                                              height: `${29}px`,
                                              borderRadius: "50%",
                                              backgroundColor: "#e5e7eb",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              color: "#374151",
                                              border: "2.5px solid var(--primary-20)",
                                            }}
                                          >
                                            +{totalAvatars - 2}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        // marginBottom: "4px",
                      }}
                    >
                      <h6
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          fontWeight: "600",
                          color:
                            selectedUser?.id === user.id ? "var(--primary, #3b82f6)" : "#1e293b",
                        }}
                      >
                        {formatName(user.name)}
                      </h6>
                    </span> */}
                      {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12px",
                      color: isTyping ? "#10b981" : "#64748b",
                      display: "-webkit-box",
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      flex: 1,
                      fontStyle: isTyping ? "italic" : "normal",
                    }}
                  >
                    {isTyping
                      ? "typing..."
                      : latestMessages[userThreadId] ||
                        user.last_message_preview?.content ||
                        "Start a conversation"}
                  </p>
                </div> */}
                    </div>{" "}
                  </>
                ) : (
                  <UserChatBubble
                    data={user}
                    isActive={isOnline}
                    first_name={user?.first_name || ""}
                    last_name={user?.last_name || ""}
                    width={19}
                    profilePic={user?.client_avatar || user?.avatar_url || ""}
                    is_active={user?.is_active}
                  />
                )}
              </div>
            </div>
          );
        })}

        <div className="chat-sidebar-filler" aria-hidden="true" />
      </div>
    </>
  );
};

export default UsersList;
